type CreateTaskError = {
  emptyName: boolean;
  duplicateName: boolean;
  invalidDateRange: boolean;
  startDateOutOfBound: boolean;
  listNotFound: boolean;
};

const createTaskError: CreateTaskError = {
  emptyName: false,
  duplicateName: false,
  invalidDateRange: false,
  startDateOutOfBound: false,
  listNotFound: false,
};

export type { CreateTaskError };

export { createTaskError };
